// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hD7IsHYHFgTaBxHqvxTQ .popover-arrow {
  display: none !important;
}`, "",{"version":3,"sources":["webpack://./tcbase/static/js2/modules/samples/components/report_summary/cards/common/tooltip.module.scss"],"names":[],"mappings":"AAEE;EACE,wBAAA;AADJ","sourcesContent":["@import \"/tcbase/static/style/settings/settings.rl.variables.scss\"; @import \"/tcbase/static/style/settings/settings.bs.variables.scss\";\n.report_popover {\n  & :global(.popover-arrow) {\n    display: none !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"report_popover": `hD7IsHYHFgTaBxHqvxTQ`
};
export default ___CSS_LOADER_EXPORT___;
